<template>
    <div class="zone-panel">
        <div class="top-tabs">
            <div class="tab-item" v-bind:class="{'tab-item-active font-color':tabActive==='functionZone'}" @click="handleTabClick('functionZone')">整体分区</div>
            <div class="tab-item" v-bind:class="{'tab-item-active font-color':tabActive==='landUse'}" @click="handleTabClick('landUse')">用地性质</div>
        </div>
        <div class="zone-info-bar" v-for="(item,index) in infoData" :key="index">
            <div class="circle" :style="{background: item.color}"></div>
            <div class="text">{{item.key}}</div>
            <div class="number font-color">{{$common.thousandBitSeparator(item.value)}} ㎡</div>
        </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
    name: "FunctionalZone",
    data() {
        return {
            tabActive: 'functionZone',
            infoData: []
        }
    },
    created() {
        this.getZoneAxios()
    },
    watch: {
        tabActive() {
            this.getZoneAxios()
        }
    },
    methods: {
        ...mapActions('gisData', ['setGisSchemeAsync']),
        //获取分区信息
        getZoneAxios() {
            let _this = this;
            let url = `${window.pubilc_config.digitalServerurl}/v1/digital/function_zone`
            this.$common.getTokenRequest()
            .get(url + '?groupBy=' + _this.tabActive)
            .then(res => {
              if (res.status === 200) {
                let data = res.data;
                if(data.code === 0) {
                    _this.infoData = data.data;
                    let sheme = {
                        field: 'BLK',
                        colorInfo: {}
                    }
                    for(let item of data.data) {
                        for(let lot of item.lots) {
                            sheme.colorInfo[lot] = item.color
                        }
                    }
                    _this.setGisSchemeAsync(sheme)
                }
              }
            }).catch(err=>{
              console.log(err,'===/v1/digital/function_zone')
            })
        },
        //tab切换
        handleTabClick(data) {
            this.tabActive = data;
        }
    }
}
</script>

<style lang="scss" scoped>
.zone-panel {
    position: relative;
    width: 100%;
    .top-tabs {
        position: relative;
        margin: 0 auto;
        width: 186px;
        height: 44px;
        display: flex;
        justify-content: space-between;
        margin-bottom: 20px;
        font-family: SourceHanSansCN-Bold;
        color: #fff;
        font-weight: bold;
        font-size: 16px;
        .tab-item {
            width: 88px;
            height: 100%;
            background: linear-gradient(180deg, rgba(255, 255, 255, 0), rgba(255, 255, 255, 0.24));
            border-radius: 3px;
            display: flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;
        }
        .tab-item-active {
            background: linear-gradient(180deg, rgba(27, 109, 183, 0), rgba(27, 109, 183, 0.72));
        }
    }
    .zone-info-bar {
        display: flex;
        align-items: center;
        width: 100%;
        font-size: 14px;
        font-family: SourceHanSansCN-Medium;
        font-weight: 600;
        color: #fff;
        margin: 6px 0;
        .circle {
            width: 20px;
            height: 20px;
            border-radius: 50%;
            margin-right: 14px;
        }
        .text {
            width: 100px;
            word-wrap: break-word;
        }
        .number {
            flex: 1;
            text-align: right;
        }
    }
}
</style>
